import { useCallback, useEffect } from "react";
import type * as IOG from "@bracket/in-or-out-server";
import { useInOrOutStore } from "../../store/InOrOutStore";

export type RecentWinRecord = {
  id: string;
  choice: IOG.Choice;
  time: number;
  total_bars: number;
};

export type TableRecentWinsData = RecentWinRecord[];

const generateRandomAddress = (): string => {
  return `0x${[...Array(20)]
    .map(() =>
      Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0")
    )
    .join("")}`;
};

const generateRandomChoice = (): IOG.Choice => {
  const choices: IOG.Choice[] = ["IN", "OUT"];
  return choices[Math.floor(Math.random() * choices.length)];
};

const generateRandomBars = (): number => {
  const barValues = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];
  return barValues[Math.floor(Math.random() * barValues.length)];
};

export const useRandomRecentWins = () => {
  const { tableRecentBars, setTableRecentBars } = useInOrOutStore();

  const addRandomPlayerRecords = () => {
    const numberOfRecords = Math.floor(Math.random() * 3) + 1;

    const newRecords = Array.from({ length: numberOfRecords }, () => ({
      id: generateRandomAddress(),
      choice: generateRandomChoice(),
      time: Date.now(),
      total_bars: generateRandomBars(),
    }));

    setTableRecentBars(newRecords);
  };

  useEffect(() => {
    let timeout;

    const updateWithRandomInterval = () => {
      addRandomPlayerRecords();

      const randomInterval =
        Math.floor(Math.random() * (6000 - 3000 + 1)) + 3000;

      timeout = setTimeout(updateWithRandomInterval, randomInterval);
    };

    updateWithRandomInterval();

    return () => timeout && clearTimeout(timeout);
  }, []);
};
